import axiosAdmin from "api/axiosAdmin";
import { Loader2 } from "lucide-react";
import React, { useState } from "react";
import { toast } from "react-toastify";

const InvitationsPage = () => {
  const [inviteEmail, setInviteEmail] = useState("");
  const [welcomeEmail, setWelcomeEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendInvite = async () => {
    setLoading(true);
    try {
      await axiosAdmin.post("/invitation/dj/create", {
        email: inviteEmail,
      });

      toast.success("Invitation sent successfully!");
      setInviteEmail("");
    } catch (err) {
      console.error(err);
      toast.error("Failed to send invite email");
    } finally {
      setLoading(false);
    }
  };

  const handleSendWelcome = async () => {
    setLoading(true);
    try {
      await axiosAdmin.post("/invitation/dj/welcome", {
        email: welcomeEmail,
      });

      toast.success("Welcome email sent successfully!");
      setWelcomeEmail("");
    } catch (err) {
      console.error(err);
      toast.error("Failed to send welcome email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="relative p-4 bg-white shadow-md rounded-lg space-y-10">
        {/* Fullscreen Loader */}
        {loading && (
          <div className="absolute inset-0 z-10 bg-white bg-opacity-60 flex items-center justify-center rounded-lg">
            <Loader2 className="w-8 h-8 animate-spin text-gray-700" />
          </div>
        )}

        {/* Registration Invite */}
        <div className="space-y-3">
          <h2 className="text-lg font-bold">Send Registration Invite</h2>
          <input
            type="email"
            value={inviteEmail}
            onChange={(e) => setInviteEmail(e.target.value)}
            placeholder="Email"
            className="w-full border p-2 rounded"
          />
          <button
            type="submit"
            disabled={!inviteEmail}
            onClick={handleSendInvite}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Send
          </button>
        </div>
      </div>
      <div className="relative p-4 bg-white shadow-md rounded-lg space-y-10 mt-6">
        {/* Welcome Email */}
        <div className="space-y-3">
          <h2 className="text-lg font-bold">Send Welcome Email</h2>
          <input
            type="email"
            value={welcomeEmail}
            onChange={(e) => setWelcomeEmail(e.target.value)}
            placeholder="Email"
            className="w-full border p-2 rounded"
          />
          <button
            type="submit"
            disabled={!welcomeEmail}
            onClick={handleSendWelcome}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvitationsPage;
